import axios from 'axios';
// Constantes a utilizar en la aplicación

/** DESARROLLO */
// export const CAFFENIO_AUTH_URL = "http://auth.vasopinguino.com";
// export const  CAFFENIO_AUTH_PSW_RESTORE = `${CAFFENIO_AUTH_URL}/change-password`;
// export const CAFFENIO_AUTH_ID = "41C7F9AB-6251-4CEF-8D9B-DD6763788DBF";
// export const API_URL = "http://127.0.0.1:8000/";
// export const API_PAPU_URL = "http://127.0.0.1:8001/";
export const dayFechaEntrega = 1;
export const timerBloqueo = 5;

/** PRUEBAS */
// export const CAFFENIO_AUTH_URL = "http://auth.vasopinguino.com";
// export const  CAFFENIO_AUTH_PSW_RESTORE = `${CAFFENIO_AUTH_URL}/change-password`;
// export const CAFFENIO_AUTH_ID = "41C7F9AB-6251-4CEF-8D9B-DD6763788DBF";
// export const API_URL = "http://apipedidosugeridobarra.vasopinguino.com:9108/";
// export const API_PAPU_URL = "http://apipapu.vasopinguino.com:8000";


/** PRE PRODUCTIVO */
//export const CAFFENIO_AUTH_URL = "https://auth.caffenio.com";
//export const  CAFFENIO_AUTH_PSW_RESTORE = `${CAFFENIO_AUTH_URL}/change-password`;
//export const CAFFENIO_AUTH_ID = "41C7F9AB-6251-4CEF-8D9B-DD6763788DBF";
//export const API_URL = "http://10.1.4.199:8024/";
// export const API_PAPU_URL = "http://10.1.4.199:8017";

export const CAFFENIO_AUTH_URL = "https://auth.caffenio.com";
export const CAFFENIO_AUTH_PSW_RESTORE = `${CAFFENIO_AUTH_URL}/change-password`;
export const CAFFENIO_AUTH_ID = "41C7F9AB-6251-4CEF-8D9B-DD6763788DBF";
export const API_URL = "https://apipedidosugerido.caffenio.com/";
export const API_PAPU_URL = "https://apipapu.caffenio.com";
/**
 * Constante para solicitudes
 */
export const REQUEST = axios.create({
    baseURL: API_URL,
    headers: { 
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type':'application/json' 
    }
})

/**
 * Constante para la solicitud a CAFFENIO Auth
 */
export const AUTH_REQUEST = axios.create({
    baseURL: CAFFENIO_AUTH_URL,
    headers: { 'Content-Type':'application/x-www-form-urlencoded' }
})

/**
 * Constante para generar el menú dinamicamente
 */
export const MENU = {
    
}